<template>
  <section :id="`${cms.scroll_id}`" v-editable="cms" :class="[name]">
    <grid
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: '1fr',
          gap: '6px',
        },
        {
          size: 2,
          columns: '1fr',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="`${name}__grid-item`"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
        ]"
      >
        <div v-if="!loadError">
          <a-copy
            :cms="{
              heading: jobTitle,
              heading_size: 'h3',
              copy: jobDescription,
            }"
          />
          <a-cta-v2
            v-if="jobDescription.length > 1"
            :cms="{
              copy: 'Apply',
              type: 'primary',
              href: { url: jobHref },
            }"
          />
        </div>
        <div v-else>
          <a-copy
            :cms="{
              copy: jobIDError ? cms.copy_id_error : cms.copy_load_error,
            }"
          />
        </div>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import data from '~/components/organisms/o-job-detail/o-job-detail.data'
import ACtaV2 from '~/components/atoms/a-ctas/a-cta-v2'
import Colors from '~/mixins/colors'
import Jobs from '~/mixins/jobs'

export default {
  components: { ACtaV2 },
  mixins: [Colors, Jobs],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'o-job-detail',
      loadError: false,
      jobIDError: false,
      jobTitle: '',
      jobDescription: '',
      jobHref: '#',
    }
  },

  async mounted() {
    if (!this.$route.query.id) {
      this.loadError = true
      return
    }

    try {
      const greenhouseData = await this.fetchJobById(this.$route.query.id)

      if (greenhouseData.error) {
        this.loadError = true
        this.jobIDError = true
        return false
      }

      this.jobDescription = this.decodeHTML(greenhouseData.content)
      this.jobTitle = greenhouseData.title
      this.jobHref = greenhouseData.absolute_url
    } catch (error) {
      this.jobIDError = true
    }
  },

  methods: {
    decodeHTML(html) {
      const txt = document.createElement('textarea')
      txt.innerHTML = html

      return txt.value
    },
  },
}
</script>

<style lang="scss" scoped>
.o-job-detail {
  background: white;
  color: black;
  padding-top: 100px;

  .a-cta {
    margin-top: 20px;
  }
}
</style>
